import React from "react";
import banner from "../../assets/01_Home/HYUNDAIKONA_17.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-concesionarios-component"
      style={{ backgroundImage: `url(${banner})` }}
    >
      {/* CAMBIADO DE DIV A H1 */}
      <h1 className="mascara-banner-concesionarios-component">
        Ubica una vitrina cerca de ti
      </h1>
    </div>
  );
};

export default BannerComponent;